/**
 * Utility functions for handling image URLs
 */

/**
 * Constructs the correct image URL based on whether the path is a full URL or relative path
 * @param imgPath - The image path from the database (can be full URL or relative path)
 * @param baseUrl - The base URL for relative paths (default: http://localhost:4010)
 * @returns The complete image URL
 */
export const getImageUrl = (imgPath: string, baseUrl: string = 'http://localhost:4010'): string => {
  if (!imgPath) return '';
  
  // If it's already a full URL (starts with http/https), return as is
  if (imgPath.startsWith('http')) {
    return imgPath;
  }
  
  // If it's a relative path, prepend the base URL
  return `${baseUrl}${imgPath}`;
};

/**
 * Checks if an image path is a full URL
 * @param imgPath - The image path to check
 * @returns true if it's a full URL, false otherwise
 */
export const isFullUrl = (imgPath: string): boolean => {
  return imgPath.startsWith('http');
};
